module.exports = __webpack_public_path__ + "static/media/badge2.bd2db609.png";